import { render, staticRenderFns } from "./LayoutCenteredSidebar.vue?vue&type=template&id=badb4ef8&scoped=true&"
import script from "./LayoutCenteredSidebar.vue?vue&type=script&lang=js&"
export * from "./LayoutCenteredSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCenteredSidebar.vue?vue&type=style&index=0&id=badb4ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badb4ef8",
  null
  
)

export default component.exports